import { useState, useEffect } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, scale: 0.7, y: 16 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.7, y: 16 }}
          transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
          style={{ position: 'fixed', bottom: 32, right: 28, zIndex: 1200 }}
        >
          <Tooltip title="Nach oben" placement="left">
            <IconButton
              onClick={scrollUp}
              size="medium"
              sx={{
                background: 'linear-gradient(135deg, #D1BC8A 0%, #B8A06E 100%)',
                color: '#0F1D2E',
                width: 46, height: 46,
                boxShadow: '0 6px 24px rgba(209,188,138,0.40)',
                border: '1.5px solid rgba(209,188,138,0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #DCC99B 0%, #C4AD7E 100%)',
                  transform: 'translateY(-3px)',
                  boxShadow: '0 12px 32px rgba(209,188,138,0.55)',
                },
                transition: 'all 0.3s ease',
              }}
            >
              <KeyboardArrowUpIcon sx={{ fontSize: 22 }} />
            </IconButton>
          </Tooltip>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default function Layout({ children }) {
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Box component="main" sx={{ flex: 1 }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.3 }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </Box>
      <Footer />
      <BackToTop />
    </Box>
  );
}
